module.exports = __webpack_public_path__ + "img/Shiba-BG.0f64f65f.jpg";